import { render, staticRenderFns } from "./RechargeConfig.vue?vue&type=template&id=065f9f32&"
import script from "./RechargeConfig.vue?vue&type=script&lang=js&"
export * from "./RechargeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RechargeConfig.vue"
export default component.exports